import { ModalService } from '@philips-internal/oswald-ui-components';
import { ModalType } from '@philips-internal/oswald-ui-constants';
import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import BaseController from '../../BaseController';

@Controller({ component: 'panel-general', fragment: 'terms-and-cookies-list' })
class TermsAndCookiesController extends BaseController {

  @OnClick({ target: 'deck-privacy-notice' })
  onClickCardDeckPrivacyNotice(event: ClickEvent): void {
    const { nrSequencia } = event.value;
    ModalService.openFullscreen({
      fragment: 'terms-of-privacy-detail',
      contextData: {
        nrSequencia,
      },
      id: 'terms-of-privacy-detail',
      type: ModalType.FULLSCREEN,
      onClose: () => { return null; },
    });
  }

  @OnClick({ target: 'deck-terms-of-use' })
  onClickCardDeckTermsOfUse(event: ClickEvent): void {
    const { nrSequencia } = event.value;
    ModalService.openFullscreen({
      fragment: 'terms-of-use-detail',
      contextData: {
        nrSequencia,
      },
      id: 'terms-of-use-detail',
      type: ModalType.FULLSCREEN,
      onClose: () => { return null; },
    });
  }
}

export default TermsAndCookiesController;
